import React from 'react';
import { createComponent } from 'effector-react/compat';
import { combine } from 'effector/compat';
import App from '../app/app';
import { AppStore } from '../stores/app-store';

const mergedStore = combine(AppStore, (AppStore) => {
    return {
        ...AppStore
    }
});

const AppController = createComponent(mergedStore, (props, state) => {

    return (
        <App state={state} />
    );
});

export default AppController;